module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "assignment-overview"
  }, [(_vm.isTeacher) ? [_c('header', {
    staticClass: "page-header"
  }, [_c('a', {
    staticClass: "tag button-timid left button--show-planning print-hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGroupSettings(_vm.group)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--settings-dark"
  }), _vm._v(" Planning aanpassen")]), _c('h1', [_vm._v("klas " + _vm._s(_vm.group.name))]), _c('hr')]), _c('div', {
    staticClass: "page-content"
  }, [_c('term-nav', {
    staticClass: "print-hide",
    attrs: {
      "terms": _vm.terms,
      "currentGroupTermId": _vm.currentGroupTerm.id
    }
  }), (_vm.group.students.length === 0 && !_vm.group.archived) ? _c('empty-group-message', {
    attrs: {
      "group": _vm.group
    }
  }) : _vm._e(), _c('p', {
    staticClass: "note note--info"
  }, [_vm._v("Dit is het overzicht van alle opdrachten voor " + _vm._s(_vm.group.name) + ", verdeeld in " + _vm._s(_vm.terms.length) + " periodes: "), _c('strong', [_vm._v(_vm._s(_vm.termNames))]), _vm._v(". Elke periode bestaat uit vier blokken met verschillende opdrachten.\n          In het linker menu kunt u de periodes en voortgang bekijken. Kies "), _c('strong', [_vm._v("klas " + _vm._s(_vm.group.name))]), _vm._v(" linksboven om direct naar de huidige periode te gaan.")])], 1)] : _c('header', {
    staticClass: "page-header page-header--wide"
  }, [_c('h1', [_vm._v("Overzicht")]), _c('p', [_vm._v("Hier vind je een overzicht van alle opdrachten voor dit jaar. Wil je vast vooruitwerken? Vraag het eerst even aan je docent. Bekijk "), _c('router-link', {
    attrs: {
      "to": {
        name: 'period'
      }
    }
  }, [_vm._v("jouw opdrachtenlijst")]), _vm._v(" om aan de slag te gaan met de opdrachten van de huidige periode.")], 1), _c('hr')]), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "relative": true
    }
  }) : _vm._l((_vm.terms), function(term, index) {
    return _c('div', {
      staticClass: "assignment-overview__term"
    }, [_c('h1', {
      staticClass: "assignment-overview__term-title banner"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": _vm.isTeacher ? {
          name: 'students.overview',
          params: {
            groupTermId: term.groupTermId
          }
        } : {
          name: 'period',
          params: {
            periodId: term.periods[0].groupPeriodId
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(index + 1) + ". " + _vm._s(term.title) + "\n            ")])], 1)]), _vm._l((term.periods), function(period) {
      return _c('div', {
        staticClass: "assignment-overview__period"
      }, [_c('p', {
        staticClass: "assignment-overview__period-title tag"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'period',
            params: {
              periodId: period.groupPeriodId
            }
          }
        }
      }, [_vm._v(_vm._s(period.title))]), _c('br'), _c('span', {
        staticClass: "timid"
      }, [_vm._v(_vm._s(period.start) + " t/m " + _vm._s(period.end))])], 1), _vm._l((period.assignments), function(assignment) {
        return _c('div', {
          staticClass: "assignment-overview__assignment",
          class: {
            'assignment-overview__assignment--disabled': _vm.isDisabledAssignment(assignment)
          }
        }, [_c('router-link', {
          staticClass: "assignment-overview__link",
          attrs: {
            "to": {
              name: 'assignment',
              params: {
                assignmentId: assignment.id,
                periodId: _vm.isTeacher ? period.groupPeriodId : undefined /* necessary for teacher, but double redirects if present for student */
              }
            }
          }
        }, [_c('img', {
          staticClass: "assignment-overview__hero",
          attrs: {
            "src": assignment.image,
            "alt": assignment.title
          }
        }), _c('span', {
          staticClass: "assignment-icon",
          class: 'icon-' + assignment.type
        }), _c('h3', {
          staticClass: "assignment-overview__title"
        }, [_vm._v(_vm._s(assignment.title))]), _c('p', {
          staticClass: "assignment-overview__subtitle"
        }, [_vm._v(_vm._s(assignment.subtitle))])])], 1)
      })], 2)
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061f31ba","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/overview/TermOverview.vue
// module id = Qnuz
// module chunks = 1